import { Images } from '../assets'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
// import Logo from '../assets/images/logo/seamhealth-logo.png'

const Navigation = () => {

   const [scrollYPosition, setScrollYPosition] = React.useState(0);
   const location = useLocation();
   const [mobileNav, setMobileNav] = React.useState(false)


const handleScroll = () => {
    const newScrollYPosition = window.pageYOffset;
    setScrollYPosition(newScrollYPosition);
};

React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);


// console.log(scrollYPosition)
// console.log(location)

  return (

    <>
        <div className={
            location.pathname === '/' && scrollYPosition > 653 ? 'navbar flex items-center justify-between p-4 md:p-8 py-4 md:py-6 bg-white text-gray shadow-md' 
            : location.pathname === '/get-in-touch' && scrollYPosition > 653 ? 'navbar flex items-center justify-between p-4 md:p-8 py-4 md:py-6 bg-white text-gray shadow-md' 
            // : location.pathname !== '/get-in-touch' && location.pathname !== "" ? 'navbar flex items-center justify-between p-4 md:p-8 py-4 md:py-6 text-gray' 
            : location.pathname !== "/" && scrollYPosition > 100 ? 'navbar flex items-center justify-between p-4 md:p-8 py-4 md:py-6 bg-white text-gray shadow-md'
            // : scrollYPosition > 100  && location.pathname !="/" ?  'navbar flex items-center justify-between p-4 md:p-8 py-4 md:py-6 bg-white text-gray shadow-md'
            : 'navbar flex items-center justify-between p-4 md:p-8'}>
            <div>
                {/* Images.SeamhealthLogo */}
                
                <Link to="/"><img decoding="async" loading="eager" className='h-[22px] md:h-[27px]' src={
                    location.pathname === '/' && scrollYPosition > 653 ? Images.SeamhealthLogoAlt 
                    : location.pathname === '/get-in-touch' && scrollYPosition > 653 ? Images.SeamhealthLogoAlt 
                    : location.pathname !== '/' && location.pathname !== '/get-in-touch' ? Images.SeamhealthLogoAlt
                    : Images.SeamhealthLogo} alt="SeamHealth Logo" /></Link>
            </div>
            <div>
                {/* link */}
                <ul className='hidden md:flex header-links'>
                    <Link to="/" className={
                        location.pathname === '/' ? 'active text-primary500' : ''
                    }><li>Home</li></Link>
                    
                    <Link to="/about" className={
                        location.pathname === '/about' ? 'active text-primary500' : ''
                    }><li>About</li></Link>
                    <Link to="/services" className={
                        location.pathname.startsWith('/services') ? 'active text-primary500' : ''
                    }><li>Services</li></Link>
                    <Link to="/projects" className={
                        location.pathname.startsWith('/projects') ? 'active text-primary500' : ''
                    }><li>Projects</li></Link>
                    <a href="https://blog-dev.seamhealth.com/" target="_blank" rel="noopener noreferrer"><li>Blog</li></a>
                </ul>
            </div>
            <div className='hidden md:block'>
                <Link to={'/get-in-touch'} className={
                    location.pathname === '/get-in-touch' && scrollYPosition > 653 ? 'btn btn-primary text-white' 
                    : location.pathname === '/' && scrollYPosition > 653 ? 'btn btn-primary text-white' 
                    : location.pathname !== '/' && location.pathname !== '/get-in-touch' ? 'btn btn-primary text-white' 
                    
                    : 'btn btn-secondary text-white'}>Get in touch <img decoding="async" src={Images.ArrowUpRight} alt="" loading="lazy" /> </Link>
            </div>
            <div className='md:hidden'>
            <button
            type="button"
            onClick={() => {setMobileNav(!mobileNav);}}
            aria-label="Toggle navigation"
            className={
                    location.pathname === '/get-in-touch' && scrollYPosition > 653 ? 'btn btn-primary text-white' 
                    : location.pathname === '/' && scrollYPosition > 653 ? 'btn btn-primary text-white' 
                    : location.pathname !== '/' && location.pathname !== '/get-in-touch' ? 'btn btn-primary text-white' 
                    
                    : 'btn btn-secondary text-white'}>{mobileNav ? <img decoding="async" src={Images.CloseIcon} alt="" loading="lazy" /> : <img decoding="async" src={Images.MenuIcon} alt="" loading="lazy" /> }</button>
            </div>
        </div>

        {mobileNav ? <div className='mobile-nav'>
            
        <ul className='flex flex-col md:hidden header-links h-full justify-center items-center' style={{gap : 48, marginTop : -48}}>
                    <div data-aos="fade-up" data-aos-duration="300">
                        <Link to="/" onClick={() => setMobileNav(false)} className={
                            location.pathname === '/' ? 'active text-primary500' : ''
                        }><li>Home</li></Link>
                    </div>
                    
                    <div data-aos="fade-up" data-aos-duration="500">
                        <Link to="/about" onClick={() => setMobileNav(false)} className={
                            location.pathname === '/about' ? 'active text-primary500' : ''
                        }><li>About</li></Link>
                    </div>
                    
                    <div data-aos="fade-up" data-aos-duration="700">
                        <Link to="/services" onClick={() => setMobileNav(false)} className={
                            location.pathname.startsWith('/services') ? 'active text-primary500' : ''
                        }><li>Services</li></Link>
                    </div>
                    
                    <div data-aos="fade-up" data-aos-duration="900">
                        <Link to="/projects" onClick={() => setMobileNav(false)} className={
                            location.pathname.startsWith('/projects') ? 'active text-primary500' : ''
                        }><li>Projects</li></Link>
                    </div>
                    <div data-aos="fade-up" data-aos-duration="1000">
                        <a href="https://blog-dev.seamhealth.com/" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNav(false)}><li>Blog</li></a>
                    </div>
                    
                    <div data-aos="fade-up" data-aos-duration="1100">
                        <Link to={'/get-in-touch'} onClick={() => setMobileNav(false)} className={'btn btn-secondary text-white'}>Get in touch <img decoding="async" src={Images.ArrowUpRight} alt="" loading="lazy" /> </Link>
                    </div>
                    
                </ul>
        </div> : <></>}
        {mobileNav ? <div data-aos="fade" data-aos-duration="500" className="mobile-overlay"></div> : <></>}
    </>
  )
}

export default Navigation